module.exports = __webpack_public_path__ + "static/media/Ellipse-6.5fb64092.svg";